"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UVCLight = exports.State = void 0;
const effect_1 = require("effect");
const time_1 = require("../../../../../unit/time");
const _util_1 = require("./_util");
const Definition = __importStar(require("./common"));
const NAMESPACE = 'Culligan.Device.Capability.Consumable.Definition.UVCLight';
const TAG = 'UVCLight';
const LABEL = 'UVC Light';
exports.State = Definition.BaseState.pipe(effect_1.Schema.extend(Definition.ExpendableState)).annotations({
    identifier: `${NAMESPACE}.State`,
    title: `${LABEL} State`,
});
class UVCLight extends Definition.ExpendableInHours.extend(`${NAMESPACE}.${TAG}`)({ _tag: effect_1.Schema.tag(TAG), ...Definition.Fields }, {
    identifier: `${NAMESPACE}.${TAG}`,
    title: LABEL,
}) {
    static id = 'uvc_light';
    static label = LABEL;
    static category = Definition.Category.UVLamp;
    static expirable = false;
    static hasBatch = false;
    static State = exports.State;
    static catalogue = {
        uvc_light: this.make({
            id: 'uvc_light',
            name: 'UVC Light',
            rangeTrigger: time_1.Hour.make({ amount: 9_800 }),
            rangeExhaust: time_1.Hour.make({ amount: 10_000 }),
        }),
    };
    static legacyCatalogueItemIdMap = {
        uv_out_pro: 'uvc_light',
    };
    static CatalogueItemFromId = (0, _util_1.makeCatalogueItemFromId)(this).annotations({
        identifier: `${NAMESPACE}.CatalogueItemFromId`,
    });
}
exports.UVCLight = UVCLight;
Definition.satisfiesConstructor(UVCLight);
//# sourceMappingURL=uvc-light.js.map